export default function ({ $auth, redirect }) {
  const user = $auth.user
  // Owner and Admin currently have the same access level for admin-protected routes
  // but they are different roles that may have different permissions in the future
  if (user.role !== 'admin' && user.role !== 'owner') {
    // return redirect('/whatsapp/contacts')
  }
}
